import { type ElementType, type ReactElement } from "react";

import { styled } from "simplydo/react/styled";

import { Checkbox } from "../checkbox/Checkbox";
import type { FormRadioProps } from "./Form.types";
import { FormField } from "./FormField";

const FormRadioComponent = (props: FormRadioProps): ReactElement => {
  const { control, type: _type, ...rest } = props;
  return (
    <FormField
      {...rest}
      type="radio"
      control={(control as ElementType) || Checkbox}
    />
  );
};

export const FormRadio = styled(FormRadioComponent)``;
